import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ChangePasswordModal.module.css';   // 复用同套样式
import api from '../../../services/api';
import { useAuth } from '../../../contexts/AuthContext';

const ChangeUsernameModal = ({ open, onClose }) => {
  const { user, updateUser } = useAuth();
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState('');

  // 每次打开时用当前用户名填充
  useEffect(() => {
    if (open && user?.username) {
      setUsername(user.username);
      setError('');
      setSuccess('');
    }
  }, [open, user?.username]);

  if (!open) return null;

  const handleClose = () => {
    setUsername('');
    setError('');
    setSuccess('');
    setSubmitting(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = username.trim();

    if (!trimmed) {
      setError('用户名不能为空');
      return;
    }
    if (trimmed.length < 2) {
      setError('用户名至少 2 个字符');
      return;
    }
    if (trimmed === user?.username) {
      setError('新用户名与当前用户名相同');
      return;
    }

    setSubmitting(true);
    setError('');
    try {
      await api.put(`/users/${user.id}`, { username: trimmed });
      updateUser({ username: trimmed });
      setSuccess('用户名已更新');
      setTimeout(() => handleClose(), 800);
    } catch (err) {
      const msg =
        err?.response?.data?.detail || err?.message || '修改失败，请重试';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.backdrop} role="presentation" onClick={handleClose}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="change-username-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className={styles.header}>
          <div>
            <h2 id="change-username-title" className={styles.title}>修改用户名</h2>
            <p className={styles.subtitle}>设置一个新的用户名</p>
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={handleClose}
            aria-label="关闭"
          >
            <span className="material-symbols-rounded">close</span>
          </button>
        </header>

        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.label} htmlFor="new-username">
            用户名
          </label>
          <input
            id="new-username"
            type="text"
            className={`${styles.input} ${error ? styles.inputError : ''}`}
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError('');
              setSuccess('');
            }}
            placeholder="请输入新用户名"
            autoComplete="username"
            disabled={submitting}
            autoFocus
          />
          {error && <div className={styles.error}>{error}</div>}
          {success && (
            <div style={{ fontSize: '0.85rem', color: 'rgb(var(--theme-50))' }}>
              {success}
            </div>
          )}

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.cancelBtn}
              onClick={handleClose}
              disabled={submitting}
            >
              取消
            </button>
            <button
              type="submit"
              className={styles.submitBtn}
              disabled={submitting}
            >
              {submitting ? '提交中…' : '确认修改'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

ChangeUsernameModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChangeUsernameModal;

